import { call, put, takeLatest } from "redux-saga/effects";
import api from "../../../config/api";
import { baggageDamageClaimRequest, baggageDamageClaimSuccess, baggageDamageClaimFailure } from "../slice/baggageDamageClaimSlice";
import { config } from "../../../../src/config/global";
const BAGGAGE_DAMAGE_CLAIM_URL = config.BAGGAGE_DAMAGE_CLAIM;
const accessToken = sessionStorage.getItem("accesstoken");
const memberId = sessionStorage.getItem("memberId");
const BaggageDamageClaimData = async payload => {
  let data = {
    mode: "no-cors",
    headers: {
      "Content-Type": "application/json",
      "Access-Control-Expose-Headers": "accessToken",
      "App-Authorization": accessToken || "",
      memberId
    },
    loader: true,
    isGenericErr: true
  };
  const response = await api.post(BAGGAGE_DAMAGE_CLAIM_URL, payload, data);
  return response;
};
function* getBaggageDamageClaimData(action) {
  try {
    const {
      payload
    } = action;
    const response = yield call(BaggageDamageClaimData, payload);
    yield put(baggageDamageClaimSuccess(response.data));
  } catch (error) {
    yield put(baggageDamageClaimFailure(error));
  }
}
export function* watchBaggageDamageClaim() {
  yield takeLatest(baggageDamageClaimRequest.type, getBaggageDamageClaimData);
}